import React from 'react';
import { View, StyleSheet } from 'react-native';
import { MainColors } from '../../constants/Colors';
import BallotsList from '../../components/BallotsList';

const BallotsScreen = ({ navigation }) => {
    return (
        <View style={styles.screen}>
            <BallotsList
                createMode={false}
                showDeleted=""
                filterStatus="not_completed"
                cardPressDisabled={false}
                editButtonShown={false}
                noBallotsMessageLineOne="Awh. No ballots to show."
                noBallotsMessageLineTwo="Sad day! 😭"
                onCardPress={(id) => navigation.navigate('BallotDetails', {
                    ballotId: id
                })}
            />
        </View>
    );
}

const styles = StyleSheet.create({
    screen: {
        flex: 1,
        backgroundColor: MainColors.grayBackground,
        // This fixes scrolling on Web for the flat list
        // overflow: 'scroll',
    }
});

export default BallotsScreen;